import type { DocumentPayload, LastOCRDocument, StoredDocument } from './types'
import { isProposedDocument } from './predicates'
import type { DocumentUploaderItem } from '@app/shared/types/sf-data'
import { DocumentLinkType } from '@app/shared/types/sf-data'
import {
  isDirectUploadDocument,
  isExistingDocument,
  isExistingPermanentDocument,
} from '@app/shared/predicates'

export const getEffectiveId = (doc: DocumentUploaderItem): string => {
  if (isDirectUploadDocument(doc)) {
    return doc.unique_id
  } else if (isExistingDocument(doc)) {
    return doc.document_id.toString()
  } else if (isExistingPermanentDocument(doc)) {
    return doc.permanent_document_id.toString()
  }

  return ''
}

export const getViewingId = (doc: DocumentUploaderItem): string => {
  if (isDirectUploadDocument(doc)) {
    return ''
  } else if (isExistingDocument(doc)) {
    return doc.document_id.toString()
  } else if (isExistingPermanentDocument(doc)) {
    return doc.document_id.toString()
  }

  return ''
}

export const formatDocumentForSave = (
  id: string,
  doc: StoredDocument
): DocumentPayload => {
  if (isProposedDocument(doc) || isExistingDocument(doc)) {
    return {
      document_attributes: {
        id: parseInt(id, 10),
      },
    }
  }

  if (isDirectUploadDocument(doc)) {
    return {
      document_attributes: {
        document_direct_upload_path: doc.link,
      },
    }
  }

  // It's an existing permanent document here
  return {
    document_attributes: {
      copy_from_permanent_document_id: parseInt(id, 10),
    },
  }
}

export const normalizePreviousDocuments = (
  documents: LastOCRDocument[]
): DocumentUploaderItem[] => {
  return documents.map((file) =>
    file['forPermanentEntry?']
      ? {
          document_id: file.id,
          linkType: DocumentLinkType.PermanentDocument,
          name: file.documentFilename,
          permanent_document_id: file.permanentDocumentId,
          unique_id: `permanent-${file.permanentDocumentId}`,
        }
      : {
          document_id: file.id,
          linkType: DocumentLinkType.Document,
          name: file.documentFilename,
          unique_id: `document-${file.id}`,
        }
  )
}
